import moment from 'moment';

/** Gmail inbox column: time today, "Jan 5" this year, "1/5/23" earlier. */
export function formatEmailListDate(iso, now = moment()) {
  if (!iso) return '';
  const m = moment(iso, [moment.ISO_8601, moment.RFC_2822], true);
  if (!m.isValid()) return '';
  if (m.isSame(now, 'day')) return m.format('h:mm A');
  if (m.isSame(now, 'year')) return m.format('MMM D');
  return m.format('M/D/YY');
}
